import { useState, useEffect, useCallback } from 'react';
import { useRestaurant } from '../../context/RestaurantContext';

const useFetchAllLocationsCompanies = () => {
  const [locations, setLocations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { restaurantId, loading: restaurantLoading } = useRestaurant();

  const fetchLocations = useCallback(async () => {
   
    setIsLoading(true); 
    setError(null); 

    try {
      const url = `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/company/locations?restaurantId=${restaurantId}`;
      
      const response = await fetch(url, {
        method: 'GET',
        credentials: 'include',
      });


      if (!response.ok) {
        const errorText = await response.text();
        console.error('🔍 Error response:', errorText);
        throw new Error(`Failed to fetch locations: ${response.status} - ${errorText}`);
      }

      const data = await response.json();
      
      const locationsArray = data.data || data.locations || [];
      
      const mappedLocations = Array.isArray(locationsArray) ? locationsArray.map(loc => ({
        ...loc,
        locationId: loc.id // Add locationId property from id
      })) : [];
      
      setLocations(mappedLocations);
    
    } catch (error) {
      console.error('🔍 Error in fetchLocations:', error);
      setError(error.message);
      setLocations([]); // Ensure locations remains an empty array on error
    } finally {
      setIsLoading(false); 
    }
  }, [restaurantId]); // Added restaurantId to useCallback dependencies

  useEffect(() => {
    fetchLocations();
  }, [fetchLocations, restaurantId]); // Added restaurantId to useEffect dependencies

  // Also listen for restaurant context ready event as a backup
  useEffect(() => {
    const handleRestaurantContextReady = (event) => {
      const { restaurantId: eventRestaurantId } = event.detail;
      if (eventRestaurantId && eventRestaurantId === restaurantId) {
        // Only fetch if we have a restaurantId and it matches
        fetchLocations();
      }
    };

    window.addEventListener('restaurantContextReady', handleRestaurantContextReady);
    window.addEventListener('restaurantContextUpdated', handleRestaurantContextReady);
    
    return () => {
      window.removeEventListener('restaurantContextReady', handleRestaurantContextReady);
      window.removeEventListener('restaurantContextUpdated', handleRestaurantContextReady);
    };
  }, [fetchLocations, restaurantId]);

  return { locations, isLoading, error };
};

export default useFetchAllLocationsCompanies;
